import { createMutators, Mutators, schema, type AuthContext } from '@mesa/core/zero';
import { Zero } from '@rocicorp/zero';
import { createUseZero, useQuery } from '@rocicorp/zero/react';

import { octokit } from '@/lib/clients';

export const createZeroInstance = (
  userId: string | null,
  getToken:
    | undefined
    | ((options?: {
        template?: string;
        organizationId?: string;
        leewayInSeconds?: number;
        skipCache?: boolean;
      }) => Promise<string | null>),
  authContext?: AuthContext
): Zero<typeof schema, ReturnType<typeof createMutators>> =>
  new Zero({
    userID: userId ?? 'anon',
    auth: getToken
      ? async () => {
          const token = await getToken({ template: 'zero' });
          return token ?? undefined;
        }
      : undefined,
    schema: schema,
    mutators: createMutators({ octokit }),
    server: import.meta.env.VITE_ZERO_SYNC_URL,
    kvStore: import.meta.env.DEV ? 'mem' : 'idb',
    maxHeaderLength: 10,
    onUpdateNeeded: (updateReason) => {
      if (updateReason.type === 'SchemaVersionNotSupported') {
        // Do something custom here, like show a banner.
        // When you're ready, call `location.reload()`.
        console.log('Updating zero schema version', updateReason);
        setTimeout(() => {
          location.reload();
        }, 3000);
      }
    },
  });

export const useZero: () => Zero<typeof schema, ReturnType<typeof createMutators>> = createUseZero<
  typeof schema,
  ReturnType<typeof createMutators>
>();

export const useZeroQuery = useQuery;
